import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import LoadingWrapper from 'components/common/LoadingWrapper';
import { Typography } from '@totalsoft/rocket-ui';
import { SummaryPropertyValueWrapper, SummaryPropertyWrapper } from './InsuranceDataStyles';

const RtiSummary = ({ data, insuranceDataLoading, assetDataLoading }) => {
  const { t } = useTranslation();

  return (
    <Grid container alignItems='center' justifyContent='space-between' spacing={2}>
      <SummaryPropertyWrapper item container alignItems='center' xs={12} md={6}>
        <Typography fontWeight='bold'>{`${t('Offer.Edit.RtiSummary.AssetType')}: `}</Typography>
        <SummaryPropertyValueWrapper>
          <LoadingWrapper loading={assetDataLoading}>
            <span id='Rti_Summary_AssetType'>{data.assetType || ''}</span>
          </LoadingWrapper>
        </SummaryPropertyValueWrapper>
      </SummaryPropertyWrapper>

      <SummaryPropertyWrapper item container alignItems='center' xs={12} md={3}>
        <Typography fontWeight='bold'>{`${t('Offer.Edit.RtiSummary.AssetPriceWithVAT')}: `}</Typography>
        <SummaryPropertyValueWrapper>
          <LoadingWrapper loading={assetDataLoading}>
            <span id='Rti_Summary_AssetPrice'>
              {t('Offer.Edit.RtiSummary.Price', {
                amount: data.purchasePrice,
                currency: data.currencyCode
              })}
            </span>
          </LoadingWrapper>
        </SummaryPropertyValueWrapper>
      </SummaryPropertyWrapper>

      <SummaryPropertyWrapper item container alignItems='center' xs={12} md={3}>
        <Typography fontWeight='bold'>{`${t('Offer.Edit.Rti.Period')}: `}</Typography>
        <SummaryPropertyValueWrapper>
          <LoadingWrapper loading={insuranceDataLoading}>
            <span id='Rti_Summary_Period'>
              {t('Offer.Edit.RtiSummary.Period', {
                period: data.period
              })}
            </span>
          </LoadingWrapper>
        </SummaryPropertyValueWrapper>
      </SummaryPropertyWrapper>
    </Grid>
  );
};

RtiSummary.propTypes = {
  data: PropTypes.object,
  insuranceDataLoading: PropTypes.bool.isRequired,
  assetDataLoading: PropTypes.bool.isRequired
};

export default RtiSummary;
